import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JuniorPilotItemComponent } from './junior-pilot-item.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [JuniorPilotItemComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [JuniorPilotItemComponent],
})
export class JuniorPilotItemModule {}
